/// <amd-module name="Artifacts/Package/services/UpstreamVersionsService" />
import * as Constants from "Artifacts/Root/Constants";
import { loadNonNullData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { UpstreamVersionsData } from "Artifacts/Root/types/PackagingShared";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IUpstreamVersionsData {
  upstreamVersionsData: UpstreamVersionsData;
}

export interface IUpstreamVersionsService extends IVssService {
  getUpstreamVersionsData(
    pageContext: IVssPageContext,
    feedId: string,
    protocol: string,
    packagename: string,
    projectId?: string,
  ): Promise<IUpstreamVersionsData>;
}

export class UpstreamVersionsService extends VssService implements IUpstreamVersionsService {
  async getUpstreamVersionsData(
    pageContext: IVssPageContext,
    feedId: string,
    protocol: string,
    packageName: string,
    projectId?: string,
  ): Promise<IUpstreamVersionsData> {
    const properties = {
      projectId: projectId,
      feedId: feedId,
      protocol: protocol,
      packageName: packageName, // will also accept packageId
    };

    const upstreamVersionsData = await loadNonNullData<UpstreamVersionsData>(
      pageContext,
      "ms.azure-artifacts.upstream-versions-data-provider",
      properties,
      true,
      Constants.CommonConstants.PackagingServiceInstanceId,
    );

    return {
      upstreamVersionsData: upstreamVersionsData,
    };
  }
}

Services.add("IUpstreamVersionsService", { serviceFactory: UpstreamVersionsService });
